<script lang="ts">
    import { onMount } from 'svelte';
    import { Deliverable, storeDeliverablesPlenaries } from "../scripts/deliverable";
    import type {PlenaryInterface} from "../scripts/plenary";
    import { storeLanguage, lang_fr } from "../scripts/store";

    export let props: PlenaryInterface;
    let deliverablesPlenary: Deliverable[] = [];
    let isOpen: boolean = false;
    let collapseHeight: number = 1;

    onMount(async () => {
        getDeliverablesPlenaries();
	});

    /**
     * getDeliverablesPlenaries
     */
     function getDeliverablesPlenaries() {
        deliverablesPlenary = $storeDeliverablesPlenaries.filter((deliverable) => {
            return deliverable.plenary_id == props.id;
        });
        collapseHeight = deliverablesPlenary.length;
    }

    function toogleIsOpen() {
        isOpen = !isOpen;
    }

</script>
    
<style lang="scss">

    $open-size: 50px;

    .plenary {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        width: 100%;
        border: 1px solid black;
        border-radius: 10px;
        max-height: 65px;
        height: auto;
        overflow: hidden;
        transition: max-height;
        transition-duration: 1s;
        margin: 0 0 30px 0;
        padding: 15px 0 15px 0;
        &__label {
            width: 100%;
            padding: 0 0 30px 0;
            display: grid;
            grid-template-areas: "text arrow";
            grid-template-columns: 1fr 7%;
            justify-content: flex-start;
            align-items: baseline;
            &__text {
                grid-area: text;
                padding: 0 0 0 15px;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                font-size: 15px;
                font-weight: 600;
                &__tiret {
                    display: none;
                }
            }
            &__arrow {
                grid-area: arrow;
                transition: transform 1s;
                transform: rotate(-60deg);
                height: 20px;
                &__open {
                    transform: rotate(0deg);
                }
            }
        }
        &__open1 {
            max-height: calc(3 * $open-size);
        }
        &__open2 {
            max-height: calc(4 * $open-size);
        }
        &__open3 {
            max-height: calc(5 * $open-size);
        }
        &__open4 {
            max-height: calc(6 * $open-size);
        }
        &__open5 {
            max-height: calc(7 * $open-size);
        }
        &__deliverable {
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            align-items: flex-start;
            padding: 0 0 0 15px;
            color: $color_accent;
            vertical-align: baseline;
            &__link {
                color: $color_accent;
                text-decoration: none;
            }
            &__arrow {
                font-size: 20px;
                margin: -5px 4px 8px 0;
            }
        }
    }

    @include large {
        .plenary {
            max-height: 25px;
            &__open1 {
                max-height: calc(2 * $open-size);
            }
            &__open2 {
                max-height: calc(3 * $open-size);
            }
            &__open3 {
                max-height: calc(4 * $open-size);
            }
            &__open4 {
                max-height: calc(5 * $open-size);
            }
            &__open5 {
                max-height: calc(6 * $open-size);
            }
            &__label {
                cursor: pointer;
                grid-template-columns: 1fr 3%;
                &__text {
                    padding: 0 0 0 30px;
                    flex-direction: row;
                    font-size: 22px;
                    &__tiret {
                        display: block;
                    }
                }
            }
            &__deliverable {
                padding: 0 0 0 50px;
            }
        }
    }

</style>

<div class="{isOpen ? 'plenary plenary__open'+collapseHeight : 'plenary'}">
    <div class="plenary__label" on:click={() => toogleIsOpen()} on:keydown={() => toogleIsOpen()}>
        <div class="plenary__label__text">
            <div class="plenary__label__text__title">{props.label}</div>
            <div class="plenary__label__text__tiret">&nbsp;-&nbsp;</div>
            <div class="plenary__label__text__date">{props.date_plenary}</div>
        </div>
        <img class="plenary__label__arrow" class:plenary__label__arrow__open={isOpen} src="../assets/images/triangle.png" alt="triangle">
    </div>
    {#each deliverablesPlenary as deliverablePlenary, i}
    <div class="plenary__deliverable">
        {#if ($storeLanguage == $lang_fr)}
        <span class="plenary__deliverable__arrow">&darr</span>
        <a class="plenary__deliverable__link" href="../assets/deliverables/plenaries/{deliverablePlenary.id}_{deliverablePlenary.file_deliverable}" target="_blank" title="Télécharger le document">
            {deliverablePlenary.title_fr}
        </a>
        {:else}
        <span class="plenary__deliverable__arrow">&darr</span>
        <a class="plenary__deliverable__link" href="../assets/deliverables/plenaries/{deliverablePlenary.id}_{deliverablePlenary.file_deliverable}" target="_blank" title="Download the document">
            {deliverablePlenary.title_en}
        </a>
        {/if}
    </div>
    {/each}
</div>
